import { render, staticRenderFns } from "./KviCartSelect.vue?vue&type=template&id=6406f4c2&scoped=true"
import script from "./KviCartSelect.vue?vue&type=script&lang=ts"
export * from "./KviCartSelect.vue?vue&type=script&lang=ts"
import style0 from "./KviCartSelect.vue?vue&type=style&index=0&id=6406f4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406f4c2",
  null
  
)

export default component.exports